import Column from '@app/components/layout/Column'
import { ContentSections } from '@app/components/blocks/contentSection/ContentSection'
import { PageMediaGallery } from '@app/components/blocks/mediaGallery/PageMediaGallery'
import { Title } from '@app/components/core/typography/Title'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'

export const DevelopmentAreas = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  return (
    <Column>
      <ContentSections sections={serviceProvider.contentBlocks || []} />
      <Title.H3>{serviceProvider.name}</Title.H3>
      <PageMediaGallery
        title={serviceProvider.name}
        images={serviceProvider.media}
      />
    </Column>
  )
}
